import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return <main className="page-center"><div className="empty-state"><h1>Halaman tidak ditemui</h1><p>Halaman Kehadiran MTIB yang diminta tidak wujud.</p><Link className="button button-primary" to="/dashboard">Ke Utama</Link></div></main>;
}
